module.exports = __webpack_public_path__ + "img/no_zone.491aebe5.svg";